import script from "./SalaryStatements.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryStatements.vue?vue&type=script&setup=true&lang=js"

import "./SalaryStatements.vue?vue&type=style&index=0&id=c5ff75ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5ff75ca"]])

export default __exports__